import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import Select from "react-select";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

const SportsList = () => {

    const [sportsList, setSportsList] = useState<any[]>([]);
    const [competitionList, setCompetitionList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [sportTypeList, setSportTypeList] = useState<any[]>([]);
    const [compCatList, setCompCatList] = useState<any[]>([]);
    const [classList, setClassList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [formatList, setFormatList] = useState<any[]>([]);
    const [athleteId, setAthleteId] = useState([]);
    const [competitionId, setCompetitionId] = useState("");
    const [sportId, setSportId] = useState("");
    const [sportTypeId, setSportTypeId] = useState("");
    const [sportStatus, setSportStatus] = useState("");
    const [compSportListId, setCompSportListId] = useState("");
    const [cmpCatId, setCmpCatId] = useState("");
    const [clsId, setClsId] = useState("");
    const [fmtId, setFmtId] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchSports();
    }, [])

    async function fetchSports() {
        setIsLoading(true);
        const sprtResponse = await func.competitionSportEvent(null);
        setSportsList(Array.isArray(sprtResponse) ? sprtResponse : [])
        setIsLoading(false);
    }

    const filteredData = sportsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const sportNameRender = (rowData) => {
        return <span>{rowData.competitionCategoryName}</span>
    };

    const sportTypeNameRender = (rowData) => {
        return <span>{rowData.sportCategoryName}</span>
    };

    const sportEventNameRender = (rowData) => {
        return <span>{rowData.sportEventName}</span>
    };

    const classNameRender = (rowData) => {
        return <span>{rowData.competitionClassName}</span>
    };

    const formatNameRender = (rowData) => {
        return <span>{rowData.competitionFormatName}</span>
    };

    const competitionNameRender = (rowData) => {
        return <span>{rowData.competitionName}</span>
    };

    const sportsStatus = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    }

    async function newSportList() {
        setOpenModal(true);
        setIsEdit(false)
        const compResponse = await func.competitions(null);
        setCompetitionList(Array.isArray(compResponse) ? compResponse : [])
        const sprtCatResponse = await func.sportCategory(null);
        setSportTypeList(Array.isArray(sprtCatResponse) ? sprtCatResponse : [])
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSportList(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const compsprtId = rowData.compSportListId;
        return (
            <Link to="#" onClick={() => deleteSportList(compsprtId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editSportList(rowData: { compSportListId: any; }) {
        const compsprtid = rowData.compSportListId;
        setOpenModal(true)
        setIsEdit(true)
        const sprtResponse = await func.competitionSport(null);
        setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
        const sprtTypResponse = await func.competitionSportType(null);
        setSportTypeList(Array.isArray(sprtTypResponse) ? sprtTypResponse : [])
        const compResponse = await func.competitions(null);
        setCompetitionList(Array.isArray(compResponse) ? compResponse : [])
        const athltResponse = await func.listActiveAthletes();
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : [])
        const getDetails = await func.sportList(compsprtid);
        setCompSportListId(getDetails.compSportListId);
        setCompetitionId(getDetails.competitionId);
        setSportId(getDetails.sportId);
        setSportTypeId(getDetails.sportTypeId);
        setAthleteId(getDetails.athleteId)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCompetitionSportList();
            } else {
                const formData = new FormData();
                formData.append("competitionid", competitionId);
                formData.append("sportcategoryid", sportTypeId);
                formData.append("sporteventid", sportId);
                formData.append("compcategoryid", cmpCatId);
                formData.append("compclassid", clsId);
                formData.append("compformatid", fmtId);
                formData.append("fromdate", startDate);
                formData.append("todate", endDate);
                // formData.append("athlete", JSON.stringify(athleteId.map(Number)));
                // formData.append("totalParticipants", totParticipants);
                const createSportEvent = api.CompetitionSportEvents;
                fetch(createSportEvent, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchSports();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updateCompetitionSportList() {
        const formData = new FormData();
        formData.append("competitionId", competitionId);
        formData.append("sportId", sportId);
        formData.append("sportTypeId", sportTypeId);
        formData.append("athlete", JSON.stringify(athleteId.map(Number)));
        // formData.append("totalParticipants", totParticipants);
        formData.append("status", sportStatus);

        const updateCompSprt = api.sportList + "/" + compSportListId;
        fetch(updateCompSprt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchSports();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteSportList(compSportListId: string) {
        const delteCompSprt = api.sportList + "/" + compSportListId + "/0";
        fetch(delteCompSprt, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchSports();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Sport Event</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newSportList() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Add Sport Event">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionName"
                                                header="Event"
                                                body={competitionNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionCategoryName"
                                                header="Event Category"
                                                body={sportNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionClassName"
                                                header="Event Class"
                                                body={classNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionFormatName"
                                                header="Event Format"
                                                body={formatNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportCategoryName"
                                                header="Sport Category"
                                                body={sportTypeNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportEventName"
                                                header="Sport"
                                                body={sportEventNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={sportsStatus}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <>
                    <Modal
                        show={openModal}
                        size="xl"
                        centered
                    >
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Sport List</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="row">
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Event</label>
                                            <Select
                                                value={competitionList.find(comp => comp.id === competitionId) ? {
                                                    value: competitionId,
                                                    label: competitionList.find(comp => comp.id === competitionId).name
                                                } : null}
                                                onChange={async (e) => {
                                                    setCompetitionId(e.value);
                                                }}
                                                required
                                                placeholder="Select Event"
                                                options={competitionList.map(coch => ({
                                                    value: coch.id,
                                                    label: coch.name
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Sport Category</label>
                                            <Select
                                                value={sportTypeList.find(spTyp => spTyp.id === sportTypeId) ? {
                                                    value: sportTypeId,
                                                    label: sportTypeList.find(spTyp => spTyp.id === sportTypeId).name
                                                } : null}
                                                onChange={async (e) => {
                                                    setSportTypeId(e.value);
                                                    const sprtResponse = await func.listSportByCategory(e.value);
                                                    setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
                                                }}
                                                required
                                                placeholder="Select Sport Category"
                                                options={sportTypeList.map(spTyp => ({
                                                    value: spTyp.id,
                                                    label: spTyp.name
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Sport</label>
                                            <Select
                                                value={sportList.find(sprt => sprt.sportsId === sportId) ? {
                                                    value: sportId,
                                                    label: sportList.find(sprt => sprt.sportsId === sportId).sportsName
                                                } : null}
                                                onChange={async (e) => {
                                                    setSportId(e.value);
                                                    const compCatResponse = await func.competitionClassesBySport(e.value);
                                                    setCompCatList(Array.isArray(compCatResponse) ? compCatResponse : [])
                                                    const classResponse = await func.competitionCategoriesBySport(e.value);
                                                    setClassList(Array.isArray(classResponse) ? classResponse : [])
                                                    const formatResponse = await func.competitionFormatBySport(e.value);
                                                    setFormatList(Array.isArray(formatResponse) ? formatResponse : [])
                                                }}
                                                required
                                                placeholder="Select Sport"
                                                options={sportList.map(sprt => ({
                                                    value: sprt.sportsId,
                                                    label: sprt.sportsName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Event Category</label>
                                            <Select
                                                value={compCatList.find(cat => cat.id === cmpCatId) ? {
                                                    value: cmpCatId,
                                                    label: compCatList.find(cat => cat.id === cmpCatId).name
                                                } : null}
                                                onChange={async (e) => {
                                                    setCmpCatId(e.value);
                                                }}
                                                required
                                                placeholder="Select Event Category"
                                                options={compCatList.map(cat => ({
                                                    value: cat.id,
                                                    label: cat.name
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Event Class</label>
                                            <Select
                                                value={classList.find(cls => cls.id === clsId) ? {
                                                    value: clsId,
                                                    label: classList.find(cls => cls.id === clsId).name
                                                } : null}
                                                onChange={async (e) => {
                                                    setClsId(e.value);
                                                }}
                                                required
                                                placeholder="Select Event Class"
                                                options={classList.map(cls => ({
                                                    value: cls.id,
                                                    label: cls.name
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Event Format</label>
                                            <Select
                                                value={formatList.find(fmt => fmt.id === fmtId) ? {
                                                    value: fmtId,
                                                    label: formatList.find(fmt => fmt.id === fmtId).name
                                                } : null}
                                                onChange={async (e) => {
                                                    setFmtId(e.value);
                                                }}
                                                required
                                                placeholder="Select Event Format"
                                                options={formatList.map(fmt => ({
                                                    value: fmt.id,
                                                    label: fmt.name
                                                }))}>
                                            </Select>
                                        </div>
                                    </div><div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Start Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="startDate"
                                                placeholder="Enter Start Date"
                                                required
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">End Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="endDate"
                                                placeholder="Enter End Date"
                                                required
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Add Athletes</label>
                                            <Select
                                                isMulti={!isEdit}
                                                value={Array.isArray(athleteList)
                                                    ? athleteList
                                                        .filter(athlt => athleteId.includes(athlt.userId))
                                                        .map(athlt => ({
                                                            value: athlt.userId,
                                                            label: athlt.athleteName
                                                        }))
                                                    : []
                                                }
                                                onChange={(selectedOptions) => {
                                                    // const selectedIds = selectedOptions.map(option => option.value);
                                                    const selectedIds = Array.isArray(selectedOptions)
                                                        ? selectedOptions.map(option => option.value)
                                                        : selectedOptions
                                                            ? [selectedOptions.value]
                                                            : [];
                                                    setAthleteId(selectedIds);
                                                }}
                                                options={Array.isArray(athleteList)
                                                    ? athleteList.map(athlt => ({
                                                        value: athlt.userId,
                                                        label: athlt.athleteName
                                                    }))
                                                    : []
                                                }
                                            />
                                        </div>
                                    </div> */}
                                    {isEdit ?
                                        <>
                                            <div className="row">
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <label className="form-label">Status</label>
                                                </div>
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                        <input
                                                            className="form-check-input text-end"
                                                            type="checkbox"
                                                            checked={sportStatus === '1'}
                                                            id="scdlStatus"
                                                            onChange={(e) => {
                                                                setSportStatus(e.target.checked ? '1' : '0')
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </> : null
                                    }
                                </div>
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                </>
            )}
        </>
    );
};

export default SportsList;